const ROUTES = {
  ANALYTICS: '/analytics',
  BILLING: '/billing',
  CONNECTIONS: '/connections',
  EXECUTIONS: '/executions',
  EXECUTIONS_ALL: '/executions/all',
  FLOWS: '/flows',
  FLOW: '/flow',
  FLOW_BUILDER: '/flow-builder',
  FLOW_DETAIL: '/call',
  FORGOT_PASSWORD: '/forgot-password',
  INDEX: '/',
  LOGIN: '/login',
  PROFILE: '/profile',
  RESET_PASSWORD: '/reset-password/:uuid/:token',
  SENTRY_ERROR: '/sentry-error',
  // WEBHOOKS: '/webhooks',
};

export default ROUTES;
